import React from 'react';
import { FETCH_ASSETS_URL } from 'appenv';
import ReactPlayerAutoplay from 'components/ReactPlayerAutoplay';

const PlayButton = `${FETCH_ASSETS_URL}/assets/play-button.png`;

const SliderVideo = ({
  url,
  thumbnail,
  onPlayVideo,
  onPauseVideo,
  active,
  autoplay = true,
}: {
  url: string;
  thumbnail?: string;
  onPauseVideo: () => void;
  onPlayVideo: () => void;
  active: boolean;
  autoplay: boolean;
}) => (
  <ReactPlayerAutoplay
    videoUrl={url}
    thumbnailUrl={thumbnail}
    videoPlayCallback={onPlayVideo}
    videoStopCallback={onPauseVideo}
    defaultPropsOverride={{
      config: {
        file: {
          attributes: {
            onLoadStart: onPlayVideo,
            disablePictureInPicture: true,
            controlsList: 'nodownload noremoteplayback',
          },
        },
      },
      style: { zIndex: 100, backgroundColor: 'black ' },
    }}
    autoPlay={autoplay}
    displayed={active}
  />
);

export default SliderVideo;
